var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('md-toolbar', [(_vm.isSignIn) ? [_c('h1', {
    staticClass: "md-title",
    staticStyle: {
      "flex": "1"
    }
  }, [_vm._v("MarkdDrive " + _vm._s(_vm.filename))]), _vm._v(" "), _c('md-button', {
    staticClass: "user-sidenav-toggle md-icon-button",
    on: {
      "click": _vm.toggleSideNav
    }
  }, [_c('md-icon', [_vm._v("account_circle")])], 1)] : [_c('h1', {
    staticClass: "md-title",
    staticStyle: {
      "flex": "1"
    }
  }, [_vm._v("MarkdDrive")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-button",
    on: {
      "click": _vm.login
    }
  }, [_c('md-icon', [_vm._v("face")]), _vm._v(" "), _c('span', [_vm._v("Sign in")])], 1)]], 2), _vm._v(" "), _c('div', {
    staticClass: "main-content"
  }, [(_vm.isSignIn) ? [_c('DriveFileList', {
    staticClass: "file-list"
  }), _vm._v(" "), _c('Editor', {
    attrs: {
      "value": _vm.value
    }
  })] : _vm._e()], 2), _vm._v(" "), (_vm.isSignIn) ? _c('md-sidenav', {
    ref: "sideNav",
    staticClass: "user-sidenav md-right md-fixed"
  }, [_c('md-toolbar', {
    staticClass: "md-large"
  }, [_c('md-avatar', {
    staticClass: "md-large",
    staticStyle: {
      "margin": "16px"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.userImageUrl,
      "alt": "People"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "md-title",
    staticStyle: {
      "flex": "1"
    }
  }, [_vm._v(_vm._s(_vm.username))])], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "sidenav-content",
    attrs: {
      "md-column": ""
    }
  }, [_c('md-layout', {
    staticStyle: {
      "overflow-y": "auto"
    }
  }, [_c('md-list', {
    staticClass: "user-actions",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('md-list-item', [_c('md-icon', [_vm._v("settings")]), _vm._v(" "), _c('span', [_vm._v("Settings")]), _vm._v(" "), _c('md-list-expand', [_c('md-list', {
    staticClass: "user-actions"
  }, [_c('md-list-item', {
    staticClass: "md-inset"
  }, [_c('md-checkbox', [_vm._v("Debug mode")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-button', {
    staticClass: "md-button",
    on: {
      "click": function($event) {
        _vm.openDialog('aboutDialog')
      }
    }
  }, [_c('md-icon', [_vm._v("info_outline")]), _vm._v(" "), _c('span', [_vm._v("About")])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-button",
    staticStyle: {
      "flex": "1"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('md-icon', [_vm._v("exit_to_app")]), _vm._v(" "), _c('span', [_vm._v("Sign out")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-dialog', {
    ref: "aboutDialog",
    staticClass: "dialog",
    attrs: {
      "md-open-from": "#about",
      "md-close-to": "#about"
    }
  }, [_c('md-dialog-title', [_vm._v("About MarkdDrive")]), _vm._v(" "), _c('md-dialog-content', [_c('p', {
    staticStyle: {
      "margin-bottom": "42px"
    }
  }, [_vm._v(_vm._s(_vm.packageInfo.description))]), _vm._v(" "), _c('md-list', {
    staticClass: "list"
  }, [_c('md-list-item', [_vm._v("v" + _vm._s(_vm.packageInfo.version))]), _vm._v(" "), _c('md-list-item', [_vm._v("License: " + _vm._s(_vm.packageInfo.license))]), _vm._v(" "), _c('md-list-item', [_c('a', {
    attrs: {
      "href": _vm.packageInfo.homepage,
      "target": "_blank"
    }
  }, [_vm._v("Home page")])]), _vm._v(" "), _c('md-list-item', [_c('a', {
    attrs: {
      "href": _vm.packageInfo.bugs.url,
      "target": "_blank"
    }
  }, [_vm._v("Report a bug")])])], 1)], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary button",
    on: {
      "click": function($event) {
        _vm.closeDialog('aboutDialog')
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4daf91f0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = zZsU
// module chunks = 1